export interface RequestAction {}

export class RequestFailure implements RequestAction {
  error: Error;

  constructor({ error }: { error: Error }) {
    this.error = error;
  }
}

export interface IRequestSuccess extends RequestAction {}
export class RequestSuccess implements IRequestSuccess {}

export abstract class RequestDataSuccess<T> implements IRequestDataSuccess<T> {
  payload: T;

  protected constructor({ payload }: { payload: T }) {
    this.payload = payload;
  }
}

export interface IRequestDataSuccess<T> extends IRequestSuccess {
  payload: T;
}
